import "./style.scss";
import { ConditionType } from "@builder/hooks/useConditions";
import { CONDITION_STRUCTURE } from "@builder/utils/constants";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import ConditionSelector from "./ConditionSelector";
import OliverText from "../OliverText";
import Button from "../Button";
import React from "react";

interface ConditionSelectorsProps {
    conditions: ConditionType[];
    handleSelect: (index: number, key: CONDITION_STRUCTURE, value: string) => void;
    removeCondition: (index: number) => void;
    addCondition: () => void;
    isEdit?: boolean;
    error: Record<string, Record<string, boolean>> | null;
    isTrigger?: boolean;
    groupIndex: number;
}

const ConditionSelectors = ({
    conditions,
    handleSelect,
    removeCondition,
    addCondition,
    isEdit = false,
    error,
    isTrigger = false,
    groupIndex
}: ConditionSelectorsProps) => {
    const { t } = useTranslation();

    const handleSourceChange = (index: number, value: string) => {
        handleSelect(index, CONDITION_STRUCTURE.SOURCE, value);
        handleSelect(index, CONDITION_STRUCTURE.CONDITION, "");
        handleSelect(index, CONDITION_STRUCTURE.TARGET, "");
    };

    const handleInput = useCallback((index: number, key: CONDITION_STRUCTURE, value: string, source: string) => {
        console.log("value from handleInput", index, key, value, source);
        if (source.toLowerCase().includes("value")) {
            if (/^\d*\.?\d{0,2}$/.test(value)) {
                handleSelect(index, key, value);
            }
        } else {
            if (/^\d*$/.test(value)) {
                handleSelect(index, key, value);
            }
        }
    }, []);

    return (
        <>
            {conditions.map((condition, index) => (
                <React.Fragment key={condition._id}>
                    <ConditionSelector
                        condition={condition}
                        index={index}
                        handleSourceChange={handleSourceChange}
                        handleInput={handleInput}
                        handleSelect={handleSelect}
                        removeCondition={removeCondition}
                        isEdit={isEdit}
                        error={error}
                        groupIndex={groupIndex}
                        conditionsLength={conditions.length}
                        conditionSources={conditions.map(condition => condition.source)}
                        isTrigger={isTrigger}
                    />
                    {conditions && conditions.length > 0 && index < conditions.length - 1 ? (
                        <div className="decision-selectors y-small">{<OliverText text={t("conditions.And")} size="xs" weight="medium-heavy" />}</div>
                    ) : (
                        <div className="add-button-wrapper">
                            <div className="decision-selectors">
                                <Button
                                    onClick={addCondition}
                                    buttonStyle="secondary"
                                    text={"And"}
                                    size="small"
                                    style={{ width: "100%", height: "32px" }}
                                />
                            </div>
                        </div>
                    )}
                </React.Fragment>
            ))}
        </>
    );
};

export default ConditionSelectors;
